import {Exclude, Expose, Type} from 'class-transformer';
import {PostApiModel} from './post-api.model';
import {ShareRefApiModel} from './share-ref.api-model';

@Exclude()
export class ShareCardApiModel {
  @Expose() public type: string;
  @Expose() public available: boolean;
  @Expose() public title?: string;
  @Expose() public subtitle?: string;
  @Expose() public content?: string;
  @Expose()
  @Type(() => PostApiModel)
  public post?: PostApiModel | null;
  @Expose()
  @Type(() => ShareRefApiModel)
  public shareRef?: ShareRefApiModel;
}
